import { Controller } from 'stimulus';
import events from 'lib/events';
import { getContentType, featureEnabled, triggerCustomEvent } from 'lib/helpers';
import { NEW_ANALYTICS_FEATURE, sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { TRENDING_CLICK } from 'components/analytics/conversions/constants/actions';

export default class TrendingSearchesController extends Controller {
  trackTrendingSearch = (event) => {
    const searchTerm = event.currentTarget.getAttribute('data-search-term');

    if (featureEnabled(NEW_ANALYTICS_FEATURE)) {
      sendTrackingEvent({
        element: event.target,
        data: {
          action: TRENDING_CLICK,
          label: `Terms-${event.currentTarget.textContent}`,
          content_type: `Content-${getContentType()}`,
        },
      });
    }

    // Keeping for Klaviyo
    triggerCustomEvent(events.search.trending_search_click, { searchTerm });
  }
}
